export function parseIso(s: string): Date {
  const d = new Date(s);
  if (Number.isNaN(d.getTime())) throw new Error(`Invalid ISO date: ${s}`);
  return d;
}

export function tryParseIso(s: string): Date | null {
  const d = new Date(s);
  return Number.isNaN(d.getTime()) ? null : d;
}

export function parseEpoch(value: number, unit: 'seconds' | 'millis' = 'millis'): Date {
  return new Date(unit === 'seconds' ? value * 1000 : value);
}

export type DateLike = Date | string | number;

export function toDate(input: DateLike): Date {
  if (input instanceof Date) return input;
  if (typeof input === 'number') return new Date(input);
  const d = new Date(input);
  if (Number.isNaN(d.getTime())) throw new Error(`Invalid date input: ${input}`);
  return d;
}
